import { FontStyles } from '@styles/fonts';
import { IconConfig } from '@components/operatorPanel/interfaces';

export const DASHBOARD_BACK_BUTTON_FONT_TYPE: keyof FontStyles = 'Button 1';

export const DASHBOARD_BACK_BUTTON_ICON_CONFIG: Partial<IconConfig> = {
  width: 8,
  height: 14,
};
